import { DefaultState } from '@src/redux/types'

import { STUDENT_PAYMENTS_PRINCIPAL } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [STUDENT_PAYMENTS_PRINCIPAL]: DefaultState<`${typeof API.STUDENT_PAYMENTS_PRINCIPAL}`, 'get'>
} = () => ({
  [STUDENT_PAYMENTS_PRINCIPAL]: defaultState(),
})
